<template>
  <div class="c-led-pcb" v-visible="!loading">
    <img class="background" :src="images.led_in_switch_alice" @load="onLoad" />
    <div class="leds">
      <div
        v-for="LED in LEDs"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft({ color: frameRGB[LED.index], index: LED.index })
        "
        @mousedown.right="
          onMouseDownRight({ color: frameRGB[LED.index], index: LED.index })
        "
        @mouseenter="
          onMouseEnter({ color: frameRGB[LED.index], index: LED.index }, $event)
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: frameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: frameRGB[LED.index],
              boxShadow: `0 0 0.45rem 0.2rem ${frameRGB[LED.index]}`,
              opacity: 1 || getLight(frameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { speedList } from "@/utils";

export default {
  name: "CLedPcbAlice",
  props: {
    isPlaying: Boolean,
    speed: Number,
    frames: Array,
    frameIndex: Number,
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
      LEDs: [
        {
          index: 0,
          style: { top: "12.2%", left: "8.9%" },
        },
        {
          index: 1,
          style: { top: "13.5%", left: "14.0%" },
        },
        {
          index: 2,
          style: { top: "13.4%", left: "18.1%" },
        },
        {
          index: 3,
          style: { top: "11.9%", left: "22.2%" },
        },
        {
          index: 4,
          style: { top: "14.1%", left: "26.7%", transform: "rotateZ(12deg)" },
        },
        {
          index: 5,
          style: { top: "16.5%", left: "30.8%", transform: "rotateZ(12deg)" },
        },
        {
          index: 6,
          style: { top: "19.1%", left: "35.0%", transform: "rotateZ(12deg)" },
        },
        {
          index: 20,
          style: { top: "21.5%", left: "39.1%", transform: "rotateZ(12deg)" },
        },
        {
          index: 7,
          style: { top: "20.6%", left: "58.3%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 8,
          style: { top: "18.2%", left: "62.5%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 9,
          style: { top: "15.7%", left: "66.6%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 10,
          style: { top: "13.3%", left: "70.7%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 11,
          style: { top: "12.0%", left: "75.2%" },
        },
        {
          index: 12,
          style: { top: "13.2%", left: "79.2%" },
        },
        {
          index: 13,
          style: { top: "13.2%", left: "85.5%" },
        },
        {
          index: 14,
          style: { top: "24.1%", left: "8.1%" },
        },
        {
          index: 15,
          style: { top: "25.4%", left: "14.1%" },
        },
        {
          index: 16,
          style: { top: "25.4%", left: "19.3%" },
        },
        {
          index: 17,
          style: { top: "24.8%", left: "23.8%", transform: "rotateZ(12deg)" },
        },
        {
          index: 18,
          style: { top: "27.1%", left: "27.9%", transform: "rotateZ(12deg)" },
        },
        {
          index: 19,
          style: { top: "29.6%", left: "32.0%", transform: "rotateZ(12deg)" },
        },
        {
          index: 34,
          style: { top: "32.2%", left: "36.1%", transform: "rotateZ(12deg)" },
        },
        {
          index: 35,
          style: { top: "33.7%", left: "57.1%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 21,
          style: { top: "31.1%", left: "61.3%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 22,
          style: { top: "28.7%", left: "65.4%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 23,
          style: { top: "26.2%", left: "69.5%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 24,
          style: { top: "24.6%", left: "74.0%" },
        },
        {
          index: 25,
          style: { top: "25.2%", left: "78.1%" },
        },
        {
          index: 26,
          style: { top: "25.2%", left: "82.2%" },
        },
        {
          index: 27,
          style: { top: "25.3%", left: "87.4%" },
        },
        {
          index: 28,
          style: { top: "36.0%", left: "7.2%" },
        },
        {
          index: 29,
          style: { top: "37.4%", left: "13.7%" },
        },
        {
          index: 30,
          style: { top: "37.3%", left: "19.4%" },
        },
        {
          index: 31,
          style: { top: "37.0%", left: "24.0%", transform: "rotateZ(12deg)" },
        },
        {
          index: 32,
          style: { top: "39.5%", left: "28.1%", transform: "rotateZ(12deg)" },
        },
        {
          index: 33,
          style: { top: "42.2%", left: "32.2%", transform: "rotateZ(12deg)" },
        },
        {
          index: 48,
          style: { top: "44.6%", left: "36.3%", transform: "rotateZ(12deg)" },
        },
        {
          index: 49,
          style: { top: "45.1%", left: "59.0%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 36,
          style: { top: "42.5%", left: "63.2%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 37,
          style: { top: "40.0%", left: "67.3%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 38,
          style: { top: "37.4%", left: "71.4%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 39,
          style: { top: "37.3%", left: "75.9%" },
        },
        {
          index: 40,
          style: { top: "37.3%", left: "80.1%" },
        },
        {
          index: 41,
          style: { top: "37.3%", left: "86.8%" },
        },
        {
          index: 42,
          style: { top: "48.0%", left: "6.3%" },
        },
        {
          index: 43,
          style: { top: "49.4%", left: "13.8%" },
        },
        {
          index: 44,
          style: { top: "49.4%", left: "20.6%" },
        },
        {
          index: 45,
          style: { top: "50.2%", left: "25.2%", transform: "rotateZ(12deg)" },
        },
        {
          index: 46,
          style: { top: "52.7%", left: "29.2%", transform: "rotateZ(12deg)" },
        },
        {
          index: 47,
          style: { top: "55.1%", left: "33.3%", transform: "rotateZ(12deg)" },
        },
        {
          index: 62,
          style: { top: "57.7%", left: "37.5%", transform: "rotateZ(12deg)" },
        },
        {
          index: 63,
          style: { top: "58.0%", left: "57.8%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 64,
          style: { top: "55.7%", left: "62.0%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 50,
          style: { top: "53.0%", left: "66.1%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 51,
          style: { top: "50.4%", left: "70.2%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 52,
          style: { top: "49.3%", left: "74.7%" },
        },
        {
          index: 53,
          style: { top: "49.2%", left: "78.9%" },
        },
        {
          index: 54,
          style: { top: "49.2%", left: "83.0%" },
        },
        {
          index: 55,
          style: { top: "49.2%", left: "88.7%" },
        },
        {
          index: 57,
          style: { top: "61.3%", left: "11.8%" },
        },
        {
          index: 58,
          style: { top: "61.4%", left: "17.0%" },
        },
        {
          index: 59,
          style: { top: "63.5%", left: "26.8%", transform: "rotateZ(12deg)" },
        },
        {
          index: 61,
          style: { top: "68.0%", left: "34.0%", transform: "rotateZ(12deg)" },
        },
        {
          index: 65,
          style: { top: "67.8%", left: "62.3%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 66,
          disabled: true,
          style: { top: "62.8%", left: "70.6%", transform: "rotateZ(-12deg)" },
        },
        {
          index: 67,
          style: { top: "61.2%", left: "78.9%" },
        },
        {
          index: 68,
          style: { top: "61.2%", left: "83.0%" },
        },
        {
          index: 69,
          style: { top: "61.2%", left: "87.2%" },
        },
        {
          index: 70,
          style: { top: "80.2%", left: "50.7%" },
        },
        {
          index: 71,
          style: { top: "12.2%", left: "50.7%" },
        },
        {
          index: 72,
          style: { top: "12.2%", left: "45.5%" },
        },
        {
          index: 73,
          style: { top: "80.2%", left: "45.5%" },
        },
      ],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frame_RGB : [];
      }
      return [];
    },
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    getLight(hex) {
      const regs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(regs[1], 16);
      let g = parseInt(regs[2], 16);
      let b = parseInt(regs[3], 16);

      (r /= 255), (g /= 255), (b /= 255);

      const max = Math.max(r, g, b);
      const light = max * 2;
      return light.toFixed(3);
    },
    play() {
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        const speed = speedList[this.speed - 1] - 2;
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, speed);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }) {
      this.$emit("led-click", { color, index });
    },
    onMouseDownRight({ index }) {
      this.$emit("led-click-right", { index });
    },
    onMouseEnter({ color, index }, { which, buttons }) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit("led-click", { color, index });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit("led-click-right", { index, solid: true });
      }
    },
  },
  mounted() {
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-pcb {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0%;
    top: 0%;

    .led {
      width: 3.5%;
      height: 10%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;

      &:hover .content .background {
        // display: block;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          display: none;
        }

        .center {
          width: 10px;
          height: 8px;
          left: 50%;
          top: 75%;
          margin-left: -2.5px;
          border-radius: 1px;
          position: absolute;
          filter: brightness(120%);
        }
      }
    }
  }
}
</style>
